import { StateCodeValueEnum } from 'components/driving-license-control-component/driving-license-control.props';

export const getStatusColor = (status: StateCodeValueEnum | undefined) => {
  if (status === StateCodeValueEnum.Active) {
    return 'green';
  }
  return 'grey400';
};
